import { createActionTypes, createApiActions } from '../rootActions';
import { Shift, ShiftAutoFill, ShiftCreate, ShiftDetail } from './types';

export const shiftCurrent = createApiActions<void, Shift>(createActionTypes('SHIFT_CURRENT'));

export const shiftOpen = createApiActions<void, void>(createActionTypes('SHIFT_OPEN'));

export const shiftClose = createApiActions<void, void>(createActionTypes('SHIFT_CLOSE'));

export const shiftCreate = createApiActions<ShiftCreate, void>(createActionTypes('SHIFT_CREATE'));

export const shiftDetail = createApiActions<ShiftDetail, void>(createActionTypes('SHIFT_DETAIL'));

export const shiftAutoFill = createApiActions<ShiftAutoFill, void>(createActionTypes('SHIFT_AUTOFILL'));
